// extracted by mini-css-extract-plugin
export default {"dataGrid":"GridTable_dataGrid__TG0qT"};